import * as yup from "yup";

export const editValidationSchema = yup.object().shape({
  username: yup
    .string()
    .min(3, "Tên đăng nhập phải có ít nhất 3 ký tự")
    .required("Vui lòng nhập tên đăng nhập"),
  fullname: yup.string().required("Vui lòng nhập họ và tên"),
  phone: yup
    .string()
    .matches(
      /(84|0[3|5|7|8|9])+([0-9]{8})\b/,
      "Số điện thoại không hợp lệ"
    )
    .optional()
    .nullable(),
  roles: yup
    .array()
    .of(yup.string())
    .min(1, "Vui lòng chọn ít nhất 1 quyền")
    .optional(),
  isActive: yup.boolean(),
});
